// extracted by mini-css-extract-plugin
module.exports = {"container":"WordFrequencyPage_container__3RQ9R","textAreaContainer":"WordFrequencyPage_textAreaContainer__hfe9a","buttonsContainer":"WordFrequencyPage_buttonsContainer__OmzYv"};